import styled from 'styled-components';

export const ResultsStyled = styled.div`
  margin: 80px 0;
  .container {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
  @media (min-width: 992px) {
    margin: 220px 0;
  }
`;

export const Title = styled.div`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
`;

export const Text = styled.div`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 39px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    margin-top: 30px;
  }
`;

export const ImageContainer = styled.div`
  max-width: 552px;
  img {
    width: 100%;
    object-fit: cover;
    margin-top: 47px;
    @media (min-width: 992px) {
      margin-top: 0;
    }
  }
  @media (min-width: 992px) {
    ${Title} {
      display: none;
    }
  }
`;

export const TextContainer = styled.div`
  ${Title} {
    display: none;
    @media (min-width: 992px) {
      display: block;
    }
  }
  @media (min-width: 992px) {
    max-width: 456px;
  }
`;
